import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Menu
name: Menu
category: React - Bulma
---

A `Menu` component based on Bulma `.menu`. This is used for navigation and any
time you want to group a list of links together.

This should be used with `MenuLabel`, and `MenuList` components. Component will
not render if there are no children.

See [Bulma Documentation](http://bulma.io/documentation/components/menu/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Menu>
    <MenuLabel>...</MenuLabel>
    <MenuList>
      ...
    <MenuList>
  </Menu>
```
*/
function Menu(props) {
  const {
    children, className, isInverted, ...rest
  } = props

  const classes = [
    'menu',
    className || '',
    isInverted ? 'is-inverted' : '',
  ]

  return (
    <nav
      role="navigation"
      {...rest}
      className={classes.join(' ')}
    >
      {children}
    </nav>
  )
}

Menu.defaultProps = {
  isInverted: false,
}

Menu.propTypes = {
  // Menu styles are inverted. Use on dark background.
  isInverted: PropTypes.bool,
}

export default Menu
